// ESPN serves team logos from a public CDN keyed on the lowercased team
// abbreviation. No API key, no quota, and none of the User-Agent trouble that
// `Espn::Http` exists to work around (see CLAUDE.md) -- the browser fetches the
// image directly, so it never touches our ESPN client at all.
//
// Verified against ESPN's own teams payload:
//   Green Bay -> https://a.espncdn.com/i/teamlogos/nfl/500/gb.png
//
// This deliberately does not come from /api/v1/games. That serializer sends
// `home_abbr` / `away_abbr` and no logo, and adding one would mean either
// another ESPN round trip per request or a new stored column -- for a value
// that is a pure function of the abbreviation we already have.
//
// It relies on ESPN's abbreviations, which is exactly why TEAM_NAME_TO_ABBR
// maps Washington to WSH and not WAS.

const BASE = "https://a.espncdn.com/i/teamlogos/nfl/500";

export function teamLogo(abbr) {
  if (!abbr) return null;
  return `${BASE}/${String(abbr).trim().toLowerCase()}.png`;
}
